// ユーザー系
export const userRole = {
  admin: 1,
  member: 2,
};

export const registerStatus = {
  deleted: 99,
  emailRegistered: 2,
  finished: 1,
};

// ファイル系
export const inputStatus = {
  valid: 1,
  deleted: 2,
};

export const processingStatus = {
  draft: 0,
  processing: 1,
  completed: 2,
  outputted: 3,
};

export const resultStatus = {
  valid: 1,
  deleted: 99,
};

export const ocrStatus = {
  uploaded: 1, // アップロード完了
  processing: 2, // OCR処理中
  completed: 3, // OCR処理完了
  error: 99, // エラー
};

// グループ系
export const groupStatus = {
  active: 1,
  deleted: 99,
};
